import { useCallback, useState } from "react";
import { apiFetch } from "./api";

/**
 * Запрос внутреннего штрихкода у бэкенда.
 *
 * Генерация живёт на сервере: только там уникальность проверяется против БД
 * атомарно. Возвращает готовый EAN-13 с зарезервированным внутренним префиксом.
 */
export default function useGenerateBarcode() {
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState(null);

  const generate = useCallback(async () => {
    setGenerating(true);
    setError(null);
    try {
      const data = await apiFetch("/api/product/products/generate-barcode/", { method: "POST" });
      const barcode = String(data?.barcode || "").trim();
      if (!barcode) throw new Error("Сервер вернул пустой штрихкод");
      return barcode;
    } catch (err) {
      setError(err?.message || "Не удалось сгенерировать штрихкод");
      return null;
    } finally {
      setGenerating(false);
    }
  }, []);

  return { generate, generating, error };
}
